import { Store } from "vuex";
import { namespace as portalHyperlinksNamespace } from "../modules/portal/portal-hyperlinks";
import { PortalHyperlink } from "@infoland/iprova-api";

export class PortalHyperlinksStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the portal hyperlinks */
    public get portalHyperlinks(): PortalHyperlink[] {
        return this.store.getters[`${portalHyperlinksNamespace}/portalHyperlinks`];
    }

    /** Loads the portal hyperlinks */
    public async loadPortalHyperlinks(portalId: number): Promise<PortalHyperlink[]> {
        return this.store.dispatch(`${portalHyperlinksNamespace}/getPortalHyperlinks`, portalId);
    }
}
